export default function AddressPickerApi({ makeRequest, buildRequest }) {
	function suggestAddresses(query, max = 10) {
		return buildRequest().then((req) => makeRequest(req.get('/api/AddressChecker/Suggest', {
			params: { q: query, max },
		})));
	}

	function getAddressDetails(dpid) {
		return buildRequest().then((req) => makeRequest(req.get(`/api/AddressChecker/Details/${encodeURIComponent(dpid)}`)));
	}

	return {
		suggestAddresses,
		getAddressDetails,
	};
}
